module.exports = __webpack_public_path__ + "media/packs/images/flags/PS-4cdc9ba557d5127dc5dd800686b2c65a.png";